import styled, { css } from 'styled-components';
import { Text, color, media } from '@morressier/ts';

export const Container = styled.div`
  width: 100%;
  margin: auto;
`;

export const Section = styled.div<{ isEmpty: boolean }>`
  margin-bottom: ${({ isEmpty }) => (isEmpty ? '0' : '2rem')};
`;

export const ResultsContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const PagingContainer = styled.div`
  margin-bottom: 4rem;
`;

export const PageNumber = styled(Text).attrs(
  (props: { isActive: boolean }) => props
)`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  cursor: ${({ isActive }) => (isActive ? 'default' : 'pointer')};
`;

export const LabelContainer = styled.a.attrs(
  (props: { label: string }) => props
)`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${({ label }) =>
    label === 'Next' &&
    css`
      margin-left: 1rem;
    `}
  ${({ label }) =>
    label === 'Prev' &&
    css`
      margin-right: 1rem;
    `}
  color: ${color('primaryLink')}
`;

export const Label = styled(Text).attrs((props: { label: string }) => props)`
  ${({ label }) =>
    label === 'Next' &&
    css`
      margin-right: 0.4rem;
    `}
  ${({ label }) =>
    label === 'Prev' &&
    css`
      margin-left: 0.3rem;
    `}
`;

export const CardLink = styled.a`
  text-decoration: none;
  outline: none;
  color: inherit;
  border-radius: 1rem;
`;

export const HeaderLayout = styled.div`
  ${media.xxsmall`
    padding-top: 7.5rem;
  `}
  ${media.medium`
    padding-top: 4rem;
  `}
`;

export const BorderBottom = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 2px solid #d9dbdf;
  margin-top: -14px;
`;

export const ShowLink = styled.a`
  display: inline-block;
  font-size: var(--fontSizes-normal);
  line-height: var(--lineHeights-normal);
  cursor: pointer;
  color: var(--color-blue-40);
  margin-top: 1rem;
  &:hover {
    color: var(--color-blue-20);
  }
`;
